import GameDisplay from './GameDisplay'
export default GameDisplay